






























































































import Status from '@/components/elements/statement/Status/Status.vue';
import Pagination from '@/components/base/Pagination.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
// eslint-disable-next-line no-unused-vars
import { IStatementShortInfo } from '@/utils/types';
import PreLoader from '@/components/base/PreLoader.vue';
import { dateWithoutTime } from '@/filters';

@Component({
  components: { PreLoader, Status, Pagination },
  data() {
    return {};
  },
  filters: {
    dateWithoutTime: dateWithoutTime,
  },
})
export default class StatementsList extends Vue {
  @Prop(Number) limit?: number;
  @Prop(Boolean) paginationShow?: boolean;
  @Prop({ type: String, default: 'Нет данных' }) notDataText?: string;

  @Prop({ type: Array, default: [] }) dataTable?: IStatementShortInfo;
  @Prop({ type: Boolean, default: false }) loading?: boolean;

  @Prop({ type: Number, default: null }) allCount?: number | null;
  @Prop({ type: Number, default: 1 }) currentPage?: number;
  @Prop({ type: Number, default: 15 }) pageSize?: number;

  async onChangePage(val: number) {
    this.$emit('onChangePage', val);
  }

  async onChangeLimit(val: number) {
    this.$emit('onChangeLimit', val);
  }

  go(id: string) {
    this.$emit('go', id);
  }
}
